export default __webpack_public_path__ + "static/media/accept.a531dc99.svg";